// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3119) return "static/chunks/3119-98e10e5cc1f38790.js";
	if (chunkId === 3859) return "static/chunks/3859-778eb9dc80b62d92.js";
	if (chunkId === 9617) return "static/chunks/9617-1a0fbf5360f8a8bb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2443":"96bd2f4e1db2559c","2460":"71a3786c3eb1fc51","2648":"7ec9947b1cb18321","2823":"e5db07ce5d84856a","4654":"bcd6fb472691396b","5192":"1f59d90e57386b98","5355":"affcfb986d3ac7bf","7247":"31753def986dc95a","8395":"fcbe4a1af3103ff4","9595":"6e877f26228b10ba","9718":"9ed59dc6dd32d31d"}[chunkId] + ".js";
};